import logo from "@/assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img src={logo} alt="SnapBill.my" className="h-12 w-auto mb-5 hover:scale-105 transition-transform duration-300" />
            <p className="text-muted-foreground text-sm max-w-sm leading-relaxed">
              The fastest way for Malaysian contractors to create professional quotes and get paid faster.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-display font-semibold text-foreground mb-5 text-base">Product</h3>
            <ul className="space-y-3 text-sm">
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">Features</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">Pricing</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">How It Works</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">FAQ</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-display font-semibold text-foreground mb-5 text-base">Company</h3>
            <ul className="space-y-3 text-sm">
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">About Us</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">Contact</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">Privacy Policy</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-all duration-200 hover:translate-x-1 inline-block">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-10 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-5">
            <p className="text-sm text-muted-foreground">
              © {currentYear} SnapBill.my. All rights reserved.
            </p>
            <div className="flex items-center gap-8 text-sm text-muted-foreground">
              <a href="#" className="hover:text-primary transition-all duration-200 hover:scale-110 inline-block">Facebook</a>
              <a href="#" className="hover:text-primary transition-all duration-200 hover:scale-110 inline-block">Instagram</a>
              <a href="#" className="hover:text-primary transition-all duration-200 hover:scale-110 inline-block">LinkedIn</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
